import { createContext } from 'react';

/**
 * DEV NOTE: These source apps need to match the source apps in
 * automation-ui-source-apps/static/js/constants/SourceApps.ts
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
const sourceApps = {
  ADS_FLOW: 'ADS_FLOW',
  ADVANCED_TICKET_SLAS: 'ADVANCED_TICKET_SLAS',
  CALLING_IVR_APP: 'CALLING_IVR_APP',
  CMS_FORM_MODULE_FIELD: 'CMS_FORM_MODULE_FIELD',
  CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL: 'CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL',
  CRM_MIGRATION: 'CRM_MIGRATION',
  CUSTOM_OBJECT_PIPELINE_SETTINGS: 'CUSTOM_OBJECT_PIPELINE_SETTINGS',
  DEAL_PIPELINE_SETTINGS: 'DEAL_PIPELINE_SETTINGS',
  DIRECT_API: 'DIRECT_API',
  PUBLIC_API: 'PUBLIC_API',
  PUBLIC_FLOW_API: 'PUBLIC_FLOW_API',
  ECOMM: 'ECOMM',
  EMBEDDED_QUOTES: 'EMBEDDED_QUOTES',
  FEEDBACK: 'FEEDBACK',
  FEEDBACK_FOLLOW_UP: 'FEEDBACK_FOLLOW_UP',
  FORECASTING: 'FORECASTING',
  FORM_FIELD_FOLLOWUP: 'FORM_FIELD_FOLLOWUP',
  FORM_FOLLOWUP_EMAIL: 'FORM_FOLLOWUP_EMAIL',
  FORMS_APP: 'FORMS_APP',
  LEAD_AUTOMATION_RULES: 'LEAD_AUTOMATION_RULES',
  LEAD_FLOW: 'LEAD_FLOW',
  // will be deprecated once contextual automation is live
  LEAD_FLOWS_APP: 'LEAD_FLOWS_APP',
  LEAD_PIPELINE_SETTINGS: 'LEAD_PIPELINE_SETTINGS',
  MARKETING_EMAIL_AUTOMATED: 'MARKETING_EMAIL_AUTOMATED',
  RULESETS_PROSPECTING: 'RULESETS_PROSPECTING',
  SEQUENCES_CONTEXTUAL_AUTOMATION: 'SEQUENCES_CONTEXTUAL_AUTOMATION',
  SKILL_BASED_ROUTING: 'SKILL_BASED_ROUTING',
  TICKET_EMAIL_STATUS_SETTING: 'TICKET_EMAIL_STATUS_SETTING',
  TICKET_PIPELINE_SETTINGS: 'TICKET_PIPELINE_SETTINGS',
  WORKFLOWS_APP: 'WORKFLOWS_APP',
  WORKFLOWS_CLASSIC: 'WORKFLOWS_CLASSIC'
};
/**
 * The default value of createContext is useful for when a Provider isn't
 * available, such as during testing.
 */
export const AppContext = /*#__PURE__*/createContext({
  contextualEmbedReadOnly: false,
  contextualEmbedReadOnlyMode: null,
  isContextualEmbed: false,
  triggerContent: null,
  sourceApp: sourceApps.WORKFLOWS_APP
});
AppContext.displayName = 'AppContext';
export const AppContextProvider = AppContext.Provider;
export const AppContextConsumer = AppContext.Consumer;

/**
 * wireAppContext is a HOC meant to be used with components that can't support
 * multiple React Contexts.
 */

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export const wireAppContext = WrappedComponent => props => /*#__PURE__*/_jsx(AppContextConsumer, {
  children: context => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, context))
});
export default AppContext;